import { Injectable } from '@angular/core';
import { ActivatableItem } from '../../../activation/core/interface';
import { Activation } from '../../../core/account.service';

@Injectable()
export class PaginatedAppActivationTableService {
  static expandActiveProducts([activatableItems, activations]: [ActivatableItem[], Activation[]]): ActivatableItem[] {
    // Helper to get all the accounts to add to the activatable items
    const expandActiveProductsHelper = function (
      items: ActivatableItem[],
      activatableItem: ActivatableItem,
    ): ActivatableItem[] {
      items.push(activatableItem);

      // Expand the activations into the activatableItems
      if (activatableItem.allowMultipleActivations) {
        items = items.concat(
          activations
            // Grab activations that correspond to the activatableItem
            .filter((activation) => activation.appId === activatableItem.appId)
            // Add the corresponding ActivatableItem with the activationDescriptor
            .map((account) => ({
              ...activatableItem,
              descriptor: account.activationDescriptor,
              isActiveAccount: true,
            })),
        );
      }

      return items;
    };

    return activatableItems.reduce(expandActiveProductsHelper, []);
  }
}
